module.exports = __webpack_public_path__ + "img/team-2.81994c2b.jpg";